import { AppDataResponse } from 'src/pages/api/app-data';
import { searchFetcher } from 'src/utilities/searchFetcher';
import { useRouter } from 'next/router';
import useSWR from 'swr';
import { useSiteContext } from 'src/store';

const useAppData = (appId: string) => {
  const router = useRouter();
  const {
    tenantId,
    packageId,
    appContainerId,
    accreditations: accreditationsConfig,
    countryOfUse,
  } = useSiteContext();
  const { locale } = router;
  const isLocaleDefault = locale === '__default';
  const languageQuery =
    locale && !isLocaleDefault ? `&language=${router.locale}` : '';

  const countryQuery = countryOfUse ? `&country=${countryOfUse.code}` : '';
  const apiUrl = `/api/app-data?tenantId=${tenantId}&packageId=${packageId}&containerId=${appContainerId}&appId=${appId}${languageQuery}${countryQuery}`;

  const shouldFetch = router.isReady && tenantId && packageId && appContainerId;
  const fetcher = (url: string) => searchFetcher(url, accreditationsConfig);
  const { data, error, isLoading } = useSWR<AppDataResponse>(
    shouldFetch ? apiUrl : null,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  return {
    appData: data?.appData,
    isLoading,
    error,
  };
};

export default useAppData;
